import { render, staticRenderFns } from "./aiJobFitCriterion.vue?vue&type=template&id=9a66f82e&scoped=true"
import script from "./aiJobFitCriterion.vue?vue&type=script&lang=js"
export * from "./aiJobFitCriterion.vue?vue&type=script&lang=js"
import style0 from "./aiJobFitCriterion.vue?vue&type=style&index=0&id=9a66f82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a66f82e",
  null
  
)

export default component.exports